import { render, staticRenderFns } from "./FlowSavingConfig.vue?vue&type=template&id=24987dc4&scoped=true"
import script from "./FlowSavingConfig.vue?vue&type=script&lang=ts"
export * from "./FlowSavingConfig.vue?vue&type=script&lang=ts"
import style0 from "./FlowSavingConfig.vue?vue&type=style&index=0&id=24987dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24987dc4",
  null
  
)

export default component.exports